import styled from '@emotion/styled';
import { Link } from 'react-router-dom';
import { Box } from '~Styles';

export const StyledLink = styled(Link)`
  width: 100%;
  text-decoration: none; /* Removes underline on ipad */
`;

export const StyledBox = styled(Box)`
  border: 1px solid var(--colorBlueGray200);
  background: var(--colorWhite);
  border-radius: 8px;
`;

export const ChangePrinterWrapper = styled.div`
  align-self: center;
  justify-self: center;
  display: flex;
  color: #000000;
  z-index: 1;
  gap: 16px;
  flex-flow: row wrap;
  justify-content: center;
`;

export const ChangePrinterRow = styled.div`
  padding: 8px 12px;
  font-size: 20px;
  background-color: #fff;
  border-radius: 4px;
`;

export const PrintContent = styled.div`
  padding: 16px;
  margin-bottom: 24px;
  font-size: 14px;
  font-family: monospace;
  background: rgba(0, 0, 0, 0.125);
  overflow: hidden;

  div {
    overflow: hidden;
  }
`;
